import { LayoutHOC } from 'base/ui/layout/layout';
import React from 'react'
import { createProductionPlan } from './productionPlan';

export const createProductionPlanPage = (layoutHOC: LayoutHOC) => {
    return layoutHOC(createProductionPlan());
  };
